export const savProductsExtractor = (savProductsData) => {
  return savProductsData?.map((product) => {
    return {
      id: product?.id,
      name: product?.attributes?.name,
      code: product?.id,
    };
  });
};
